import { Reveal } from "./Reveal";

const STEPS = [
  { n: "01", t: "Pilih layanan", d: "Tentukan jenis layanan, durasi, dan preferensi petugas sesuai kebutuhan Anda." },
  { n: "02", t: "Isi detail booking", d: "Masukkan tanggal, alamat, dan catatan khusus. Estimasi harga langsung terlihat." },
  { n: "03", t: "Tim kami datang", d: "Petugas hadir tepat waktu dan mulai bekerja dengan sepenuh hati." },
];

export default function Process() {
  return (
    <section className="section process" id="cara-kerja">
      <div className="container">
        <Reveal className="section-head">
          <div>
            <span className="eyebrow">Cara Kerja</span>
            <h2 className="h2">
              Semudah <em>1, 2, 3.</em>
            </h2>
          </div>
          <p>Tidak perlu repot mencari. Dalam tiga langkah, rumah bersih sudah di depan mata.</p>
        </Reveal>
        <div className="steps">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="step">
              <div>
                <span className="step-num">{s.n}</span>
                <h3>{s.t}</h3>
                <p>{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
